import {
  getCapitalOffers,
  GetCapitalOffersResponse,
} from "../../../services/accountService";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

export default function useCapitalOffersQuery(
  accountHolderCode: string,
  queryOptions?: UseQueryOptions<GetCapitalOffersResponse, string>
) {
  return useQuery<GetCapitalOffersResponse, string>(
    ["capitalOffers", accountHolderCode],
    () => getCapitalOffers(accountHolderCode),
    queryOptions
  );
}
